import { AxiosInstance } from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

import * as requestUrl from "../../constants/request";

import { SchedulePayments, FetchSchedulePaymentsResult, ScheduledPaymentsFilter } from "./schedulePayments-state";

export type FetchSchedulePayments = typeof fetchSchedulePayments;

export const fetchSchedulePayments = createAsyncThunk<
FetchSchedulePaymentsResult,
  {
    request: AxiosInstance;
    data: ScheduledPaymentsFilter;
  }
>(
  "schedulePayments/fetchSchedulePayments",
  async ({ request, data: filter }, thunkAPI) => {
    try {
      const scheduledPaymentUrl = new URL(`${requestUrl.FT_SCHEDULE_PAYMENT}/query`, requestUrl.FT_REQUEST_BASE_URL);

      const paData = await request(scheduledPaymentUrl.toString(), {
        method: "post",
        data: filter
      });
      return paData.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(null);
    }
  }
);

export type UpdateSchedulePayments = typeof updateSchedulePayments;

export const updateSchedulePayments = createAsyncThunk<
  SchedulePayments,
  {
    request: AxiosInstance;
    data: SchedulePayments;
  }
>(
  "schedulePayments/updateSchedulePayments",
  async ({ request, data }, thunkAPI) => {
    const res = await request(requestUrl.FT_SCHEDULE_PAYMENT, {
      method: "PUT",
      data,
    });

    if (res.status === 204 || res.status === 200) {
      return data;
    } else {
      return thunkAPI.rejectWithValue(null);
    }
  }
);
